import React from 'react';
import { Content, Button, Flex, Text, Label, Pane, TextArea } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import S from './PairingFlow.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function UnpairOtherForm(props) {
  const {
    areaClassName,
    footerClassName,
    onClose,
    onChange,
    onUnpair,
    trackerInstallLocation,
    titleVariant,
    titleIcon,
    notes
  } = props;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Content.Header, {
      children: [/*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Unpair Locator from Vehicle",
        "data-cy": Config.get('cypress', ['text', 'locator.unpairFromVehicle'], 'text.locator.unpairFromVehicle'),
        icon: titleIcon
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeDialog",
        className: S.close,
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Content.Area, {
      className: areaClassName,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "Please describe the issue with the Locator."
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Notes"
        }), /*#__PURE__*/_jsx(TextArea, {
          eventData: "notes",
          value: notes,
          onChange: onChange
        }), /*#__PURE__*/_jsx(Pane, {
          className: S.container,
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "row",
            justify: "space-between",
            children: [/*#__PURE__*/_jsx(Text, {
              className: S.name,
              children: "Install Location"
            }), /*#__PURE__*/_jsx(Text, {
              className: S.value,
              children: trackerInstallLocation
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        onClick: onClose,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onUnpair,
        children: "Next"
      })]
    })]
  });
}